var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',[_c('v-list-item-content',[_vm._v(_vm._s(_vm.title)+":")]),_c('v-list-item-content',{staticClass:"align-end"},[_vm._v(" "+_vm._s(_vm.symbol)+_vm._s(_vm.value)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }